import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';
import { Subject } from 'rxjs';

@Directive({
  standalone: true,
  selector: '[appInputRestriction]',
})
export class InputRestrictionDirective {
  // camelCase
  // lowercase
  // lower-kebab-case
  // lower_snake_case
  // PascalCase
  // Sentencecase
  // UPPERCASE
  // UPPER-KEBAB-CASE
  // UPPER_SNAKE_CASE
  // Title Case
  protected emitEvent$: Subject<any>;

  @Input('appInputRestriction') appInputRestriction!:
    | 'integer'
    | 'alphabets'
    | 'noSpecialChars'
    | 'amount'
    | ""
    ;
  @Input('isSpaceAllow') isSpaceAllow: boolean = false;
  @Input('charList') charList: string | null = '';
  @Input('limit') public limit: number | null = null;
  @Input('upper_case') upper_case: boolean = false;
  @Input('allowCopyPaste') allowCopyPaste: boolean = false;
  @Input('bypassValidation') bypassValidation: boolean = false;

  arabicRegex = '[\u0600-\u06FF]';
  customMask: boolean = false;


  constructor() {
    this.emitEvent$ = new Subject<any>();
  }

  @HostListener('keydown', ['$event']) onKeyPress(event: KeyboardEvent) {
    if (this.bypassValidation) {
      return
    }
    // if (event.keyCode === 8) {
    //   event.preventDefault();
    //   return
    // }
    //  If the limit exceed stop here || allow if press backspace.

    if ([9, 37, 38, 39, 40].indexOf(event.keyCode) > -1) {
      return;
    }
    if ((this.allowCopyPaste === true && (event.ctrlKey === true || event.shiftKey === true || event.altKey === true))) {
      return;
    }
    let currentLength: number = ((event.target as HTMLInputElement).value).length;
    if ((this.limit && (currentLength >= this.limit)) && event.keyCode !== 8) {
      event.preventDefault();
      return
    }

    if ((!this.isSpaceAllow && event.key === " ") || (this.charList && !this.charList?.includes(event.key))) {
      event.preventDefault();
    }


    // this._renderer.setProperty(this._el.nativeElement, 'value', value);

    // if (this.appInputRestriction === 'integer') {
    //   this.integerOnly(event);
    // } else if (this.appInputRestriction === 'alphabets') {
    //   this.alphabetsOnly(event);
    // } else if (this.appInputRestriction === 'noSpecialChars') {
    //   this.noSpecialChars(event);
    // }
    if (!this.appInputRestriction) {
      return
    }
    this.checkValidation(event, this.appInputRestriction);
  }

  /*  integerOnly(event: KeyboardEvent) {
     const e = <KeyboardEvent>event;
     if (e.key === 'Tab' || e.key === 'TAB') {
       return;
     }
     // if (
     //   [46, 8, 9, 27, 13, 110].indexOf(e.keyCode) !== -1 ||
     //   // Allow: Ctrl+A
     //   (e.keyCode === 65 && e.ctrlKey === true) ||
     //   // Allow: Ctrl+C
     //   (e.keyCode === 67 && e.ctrlKey === true) ||
     //   // Allow: Ctrl+V
     //   (e.keyCode === 86 && e.ctrlKey === true) ||
     //   // Allow: Ctrl+X
     //   (e.keyCode === 88 && e.ctrlKey === true)
     // ) {
     //   // let it happen, don't do anything
     //   return;
     // }
 
 
     if (
       ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].indexOf(e.key) === -1
     ) {
       e.preventDefault();
     }
   }
 
   alphabetsOnly(event: KeyboardEvent) {
     const e = <KeyboardEvent>event;
     if (e.key === 'Tab' || e.key === 'TAB') {
       return;
     }
     let k;
     k = event.keyCode; // k = event.charCode;  (Both can be used)
     if (
       (k > 64 && k < 91) ||
       (k > 96 && k < 123) ||
       k === 8 ||
       (this.isSpaceAllow && k === 32)
     ) {
       return;
     }
     // const ch = String.fromCharCode(e.keyCode);
     // const regEx = new RegExp(this.arabicRegex);
     // if (regEx.test(ch)) {
     //     return;
     // }
     e.preventDefault();
   }
 
   noSpecialChars(event: KeyboardEvent) {
 
     const e = <KeyboardEvent>event;
     if (e.key === 'Tab' || e.key === 'TAB') {
       return;
     }
     let k;
     k = event.keyCode; // k = event.charCode;  (Both can be used)
     if (
       (k > 64 && k < 91) ||
       (k > 96 && k < 123) ||
       k === 8 ||
       (k >= 48 && k <= 57) ||
       (this.isSpaceAllow && k === 32)
     ) {
       return;
     }
     // const ch = String.fromCharCode(e.keyCode);
     // const regEx = new RegExp(this.arabicRegex);
     // if (regEx.test(ch)) {
     //     return;
     // }
     e.preventDefault();
   } */

  checkValidation(event: KeyboardEvent, appInputRestriction: string) {
    const e = <KeyboardEvent>event;

    if (e.key === 'Tab' || e.key === 'TAB') {
      return;
    }
    if (
      ((appInputRestriction === 'noSpecialChars' || appInputRestriction === 'integer') && ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'].indexOf(e.key) !== -1)
      ||
      ((appInputRestriction === 'noSpecialChars' || appInputRestriction === 'alphabets') && (e.keyCode >= 65 && e.keyCode <= 90))
      ||
      e.keyCode === 8
      ||
      (this.isSpaceAllow && e.keyCode === 32)
    ) {
      if (this.customMask) {
        e.preventDefault();
        this.emitEvent$.next(event);
      } else {
        return;
      }
    }
    e.preventDefault();
  }

  @HostListener('paste', ['$event']) onPaste(event: any) {
console.log(event);

    if (this.bypassValidation) {
      return
    }

    let regex: any;
    if (this.appInputRestriction === 'integer') {
      regex = /[0-9]/g;
    } else if (this.appInputRestriction === 'noSpecialChars') {
      if (this.isSpaceAllow) {
        let rex = /[a-zA-Z0-9]/;
        regex = new RegExp(rex + `/${this.charList as string}/`)
      }
      regex = /[a-zA-Z0-9]/g;
    } else if (this.appInputRestriction === 'alphabets') {
      regex = /[a-zA-Z ]/g;
    }

    const e: any = <ClipboardEventInit>event;
    const pasteData = (e.clipboardData as DataTransfer).getData('text/plain');

    let m;
    let matches = 0;
    while ((m = regex.exec(pasteData)) !== null) {
      // This is necessary to avoid infinite loops with zero-width matches
      if (m.index === regex.lastIndex) {
        regex.lastIndex++;
      }
      // The result can be accessed through the `m`-variable.
      m.forEach((match: any, groupIndex: number) => {
        matches++;
      });
    }
    if (matches === pasteData.length) {
      return;
    } else {
      e.preventDefault();
    }
  }
}
